module.exports = __webpack_public_path__ + "static/media/check.46c31a1c.svg";